import {EventForm} from "../../models/api/codegen/code";

export const calculateSystemOdds = (events: EventForm[]): number => {
    if (events.length >= 3) {
        const oddsArray: number[] = [];
        events.forEach(event => {
            const odds = event.odds;
            odds && oddsArray.push(odds);
        });
        return oddsArray.map((val, index) => {
            const subArray = [...oddsArray];
            subArray.splice(index, 1);
            return subArray.reduce((totalOdds, curOdds) => totalOdds * curOdds);
        }).reduce((totalOdds, curOdds) => totalOdds + curOdds);
    }
    return 0;
};

export const calculateExpressOdds = (events: EventForm[]): number => events.reduce((total, el) => {
    return el.odds ? (total * el.odds) : total
}, 1);

export const withFixed = (v: number): string => v.toFixed(2);

export const multipleRateWithFixed = (odds: number, rate: number): string => withFixed(odds * rate);

export function undefinedToZero(el: any) {
    return (el === undefined) ? 0 : el;
}